import axios from 'axios';
import { aesDecrypt } from "./aes";

const service = axios.create({
  baseURL:
    window.location.host === "www.pitagepe.com"
    ? "https://appsp.pitagepe.com"
    : "https://appst.pitagepe.com",
  timeout: 60000, // 请求超时时间
});

service.interceptors.response.use(
  (response) => {
    if(response.data.fzgz) {
      return {
        ...response.data,
        parseObj: JSON.parse(aesDecrypt(response.data.fzgz))
      };
    }else {
      return response.data;
    }
    
  },
  (error) => {
    console.log("err" + error); // for debug
  }
);

export default service;